/**
 * ZenMarkup Privacy Analytics — Utils module.
 *
 * Shared utility functions for number formatting.
 */

/**
 * Format a number into a compact human-readable string.
 *
 * Examples: 0 → "0", 999 → "999", 1500 → "1.5k", 12300 → "12.3k",
 *           1500000 → "1.5M", 1000000000 → "1B"
 *
 * @param {number} n  The number to format.
 * @return {string}
 */
export function formatCompact(n) {
	n = Number(n) || 0;

	if (n < 1000) {
		return String(n);
	}

	if (n < 1000000) {
		const val = n / 1000;
		// 999500+ rounds to 1000k — show as 1M instead.
		if (val >= 999.5) {
			return '1M';
		}
		return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1).replace(/\.0$/, '')) + 'k';
	}

	if (n < 1000000000) {
		const val = n / 1000000;
		if (val >= 999.5) {
			return '1B';
		}
		return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1).replace(/\.0$/, '')) + 'M';
	}

	const val = n / 1000000000;
	return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1).replace(/\.0$/, '')) + 'B';
}

/**
 * Title-case a device type for display.
 *
 * device_type is stored lowercase in the DB (desktop, mobile, tablet, bot).
 * Capitalization happens only at the presentation layer — never in matching.
 *
 * @param {string} type  Raw device type from the API (lowercase canonical).
 * @return {string}
 */
export function formatDeviceLabel(type) {
	const s = String(type || '').toLowerCase();
	if (!s) {
		return 'Unknown';
	}
	return s.charAt(0).toUpperCase() + s.slice(1);
}
